import React from "react"
import Header from "./components/header"
import Homepage from "./components/homepage"
import Tracker from "./components/tracker"
import Footer from "./components/footer"

function App() {
  return (
    <div>
      <Header />
      <Homepage />
      <Tracker />
      <Footer />
    </div>
  )
}

export default App
